/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Trackermodal_Openinnewtab4Inputs */

const he_extension_trackermodal_openinnewtab4 = /** @type {(inputs: Extension_Trackermodal_Openinnewtab4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פתח התחברות בלשונית חדשה`)
};

const en_extension_trackermodal_openinnewtab4 = /** @type {(inputs: Extension_Trackermodal_Openinnewtab4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open sign-in in new tab`)
};

/**
* | output |
* | --- |
* | "Open sign-in in new tab" |
*
* @param {Extension_Trackermodal_Openinnewtab4Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_trackermodal_openinnewtab4 = /** @type {((inputs?: Extension_Trackermodal_Openinnewtab4Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Trackermodal_Openinnewtab4Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_trackermodal_openinnewtab4(inputs)
	return en_extension_trackermodal_openinnewtab4(inputs)
});
export { extension_trackermodal_openinnewtab4 as "extension_trackerModal_openInNewTab" }